/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createExcelConnectionConfiguration } from '../fn/sites-excel-import-export/create-excel-connection-configuration';
import { CreateExcelConnectionConfiguration$Params } from '../fn/sites-excel-import-export/create-excel-connection-configuration';
import { ExcelConnectionConfig } from '../models/excel-connection-config';
import { ExcelConnectionConfigList } from '../models/excel-connection-config-list';
import { exportExcelConnectionTags } from '../fn/sites-excel-import-export/export-excel-connection-tags';
import { ExportExcelConnectionTags$Params } from '../fn/sites-excel-import-export/export-excel-connection-tags';
import { getExcelConnectionConfigurations } from '../fn/sites-excel-import-export/get-excel-connection-configurations';
import { GetExcelConnectionConfigurations$Params } from '../fn/sites-excel-import-export/get-excel-connection-configurations';
import { importExcelConnectionTags } from '../fn/sites-excel-import-export/import-excel-connection-tags';
import { ImportExcelConnectionTags$Params } from '../fn/sites-excel-import-export/import-excel-connection-tags';
import { listExcelConnectionConfigurations } from '../fn/sites-excel-import-export/list-excel-connection-configurations';
import { ListExcelConnectionConfigurations$Params } from '../fn/sites-excel-import-export/list-excel-connection-configurations';
import { removeExcelConnectionConfiguration } from '../fn/sites-excel-import-export/remove-excel-connection-configuration';
import { RemoveExcelConnectionConfiguration$Params } from '../fn/sites-excel-import-export/remove-excel-connection-configuration';
import { updateExcelConnectionConfiguration } from '../fn/sites-excel-import-export/update-excel-connection-configuration';
import { UpdateExcelConnectionConfiguration$Params } from '../fn/sites-excel-import-export/update-excel-connection-configuration';


/**
 * All about the sites Excel import and export
 */
@Injectable({ providedIn: 'root' })
export class SitesExcelImportExportService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listExcelConnectionConfigurations()` */
  static readonly ListExcelConnectionConfigurationsPath = '/stations/{uid}/excel';

  /**
   * List a station excel connections configurations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listExcelConnectionConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  listExcelConnectionConfigurations$Response(params: ListExcelConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<ExcelConnectionConfigList>> {
    return listExcelConnectionConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * List a station excel connections configurations.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listExcelConnectionConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listExcelConnectionConfigurations(params: ListExcelConnectionConfigurations$Params, context?: HttpContext): Observable<ExcelConnectionConfigList> {
    return this.listExcelConnectionConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExcelConnectionConfigList>): ExcelConnectionConfigList => r.body)
    );
  }

  /** Path part for operation `createExcelConnectionConfiguration()` */
  static readonly CreateExcelConnectionConfigurationPath = '/stations/{uid}/excel';

  /**
   * Create a station excel connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createExcelConnectionConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createExcelConnectionConfiguration$Response(params: CreateExcelConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<ExcelConnectionConfig>> {
    return createExcelConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a station excel connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createExcelConnectionConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createExcelConnectionConfiguration(params: CreateExcelConnectionConfiguration$Params, context?: HttpContext): Observable<ExcelConnectionConfig> {
    return this.createExcelConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExcelConnectionConfig>): ExcelConnectionConfig => r.body)
    );
  }

  /** Path part for operation `getExcelConnectionConfigurations()` */
  static readonly GetExcelConnectionConfigurationsPath = '/stations/{uid}/excel/{excelUid}';

  /**
   * Get a station excel connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExcelConnectionConfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExcelConnectionConfigurations$Response(params: GetExcelConnectionConfigurations$Params, context?: HttpContext): Observable<StrictHttpResponse<ExcelConnectionConfig>> {
    return getExcelConnectionConfigurations(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a station excel connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExcelConnectionConfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExcelConnectionConfigurations(params: GetExcelConnectionConfigurations$Params, context?: HttpContext): Observable<ExcelConnectionConfig> {
    return this.getExcelConnectionConfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExcelConnectionConfig>): ExcelConnectionConfig => r.body)
    );
  }

  /** Path part for operation `updateExcelConnectionConfiguration()` */
  static readonly UpdateExcelConnectionConfigurationPath = '/stations/{uid}/excel/{excelUid}';

  /**
   * Update a station excel connection configuration.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateExcelConnectionConfiguration()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExcelConnectionConfiguration$Response(params: UpdateExcelConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<ExcelConnectionConfig>> {
    return updateExcelConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a station excel connection configuration.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateExcelConnectionConfiguration$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExcelConnectionConfiguration(params: UpdateExcelConnectionConfiguration$Params, context?: HttpContext): Observable<ExcelConnectionConfig> {
    return this.updateExcelConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExcelConnectionConfig>): ExcelConnectionConfig => r.body)
    );
  }

  /** Path part for operation `removeExcelConnectionConfiguration()` */
  static readonly RemoveExcelConnectionConfigurationPath = '/stations/{uid}/excel/{excelUid}';

  /**
   * Remove the station excel connection configuration.
   *
   * Remove Excel connection configuration
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeExcelConnectionConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeExcelConnectionConfiguration$Response(params: RemoveExcelConnectionConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeExcelConnectionConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove the station excel connection configuration.
   *
   * Remove Excel connection configuration
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeExcelConnectionConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeExcelConnectionConfiguration(params: RemoveExcelConnectionConfiguration$Params, context?: HttpContext): Observable<void> {
    return this.removeExcelConnectionConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `exportExcelConnectionTags()` */
  static readonly ExportExcelConnectionTagsPath = '/stations/{uid}/excel/configuration/{excelUid}/export';

  /**
   * Export the tags of the excel connection of a station.
   *
   * Allows to export the tags of the excel connection of a station, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportExcelConnectionTags()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportExcelConnectionTags$Response(params: ExportExcelConnectionTags$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportExcelConnectionTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the tags of the excel connection of a station.
   *
   * Allows to export the tags of the excel connection of a station, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportExcelConnectionTags$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportExcelConnectionTags(params: ExportExcelConnectionTags$Params, context?: HttpContext): Observable<Blob> {
    return this.exportExcelConnectionTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `importExcelConnectionTags()` */
  static readonly ImportExcelConnectionTagsPath = '/stations/{uid}/excel/configuration/{excelUid}/import';

  /**
   * Import and create the tags of the excel connection of a station.
   *
   * Allows to import and create the tags of the excel connection of a station, via a XLS File.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importExcelConnectionTags()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importExcelConnectionTags$Response(params: ImportExcelConnectionTags$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importExcelConnectionTags(this.http, this.rootUrl, params, context);
  }

  /**
   * Import and create the tags of the excel connection of a station.
   *
   * Allows to import and create the tags of the excel connection of a station, via a XLS File.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importExcelConnectionTags$Response()` instead.
   *
   * This method sends `application/vnd.ms-excel` and handles request body of type `application/vnd.ms-excel`.
   */
  importExcelConnectionTags(params: ImportExcelConnectionTags$Params, context?: HttpContext): Observable<void> {
    return this.importExcelConnectionTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
